import {RestRequestGET} from 'libs/RestRequest'
import Endpoints from 'constants/Endpoints'
import reduxStore from 'redux/store'
import {clearResource, setResource, setSaveStatusDialog, setSaveStatusLoading} from 'redux/actions'
import validateSection from './helpers/validateSection'
import {DemandValidation} from 'constants/DemandValidation';

const NOTICE_LINK_RESOURCE_ID = 'noticeLink';
const NOTICE_PREVIEW_RESOURCE_ID = 'noticePreview';

const getLink = async (demandId) => {
    try {
        const res = await RestRequestGET(Endpoints.NOTICE(demandId));
        reduxStore.dispatch(
            setResource(NOTICE_LINK_RESOURCE_ID, res)
        )
    } catch (error) {
    }
}

const save = async (demandId) => {
    reduxStore.dispatch(setSaveStatusLoading());

    try {
        reduxStore.dispatch(setSaveStatusDialog());
        await validateSection(DemandValidation.NOTICE, demandId);
    } catch (error) {
    }
}

const validate = async (id) => {
    return RestRequestGET(Endpoints.NOTICE_VALIDATE(id));
}

const getPreviewUrl = async (id = -1) => {
    try {
        const res = await RestRequestGET(Endpoints.NOTICE_PREVIEW(id))
        reduxStore.dispatch(
            setResource(NOTICE_PREVIEW_RESOURCE_ID, res)
        )
    } catch (error) {
        reduxStore.dispatch(
            setResource(NOTICE_PREVIEW_RESOURCE_ID, {error: true})
        )
    }
}

const clearResources = (id) => reduxStore.dispatch(clearResource(id));


export default {
    getLink,
    getPreviewUrl,
    save,
    validate,
    clearResources,
    NOTICE_PREVIEW_RESOURCE_ID,
    NOTICE_LINK_RESOURCE_ID
};